import { isUseCaseArtworkId } from "@replohq/lattice/blocks/workflow-art/useCaseArtwork";
import { parseJsonOrNull } from "replo-utils/lib/json";
import { isOsmanthusEnabled } from "replo-utils/lib/osmanthus";
import { z } from "zod";

const stepsSchema = z
  .array(
    z.object({
      id: z.string().max(200),
      label: z.string().min(1).max(200),
      value: z.string().max(5000),
    }),
  )
  .max(30);

const stepsStorageKey = "replo.marketing-workflow-steps";

export function captureMarketingWorkflowSteps({
  hash,
  searchParams,
}: {
  hash: string;
  searchParams: URLSearchParams;
}) {
  if (!isOsmanthusEnabled()) {
    return null;
  }
  const slug = searchParams.get("marketingWorkflow");
  const serializedSteps = new URLSearchParams(hash.slice(1)).get(
    "workflowSteps",
  );
  if (!slug || !isUseCaseArtworkId(slug) || !serializedSteps) {
    return;
  }
  const steps = stepsSchema.safeParse(parseJsonOrNull(serializedSteps));
  if (steps.success) {
    sessionStorage.setItem(
      `${stepsStorageKey}:${slug}`,
      JSON.stringify(steps.data),
    );
  }
}

const marketingWorkflowSchema = z.object({
  title: z.string().trim().min(1).max(200),
  description: z.string().trim().min(1).max(600),
});

export function getMarketingWorkflow(searchParams: URLSearchParams) {
  if (!isOsmanthusEnabled()) {
    return null;
  }
  const slug = searchParams.get("marketingWorkflow");
  if (!slug || !isUseCaseArtworkId(slug)) {
    return null;
  }
  const details = marketingWorkflowSchema.safeParse({
    title: searchParams.get("workflowTitle"),
    description: searchParams.get("workflowDescription"),
  });
  const steps = stepsSchema.safeParse(
    parseJsonOrNull(
      sessionStorage.getItem(`${stepsStorageKey}:${slug}`) ?? "null",
    ),
  );
  return details.success
    ? { slug, ...details.data, steps: steps.success ? steps.data : [] }
    : null;
}
